import { ReactLenis } from "lenis/react";
import React from "react";

// Smooth momentum scrolling for marketing pages.
export default function SmoothScroll({ children }) {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
      {children}
    </ReactLenis>
  );
}
